import { lightTheme } from 'hfs-common-ui';
import { createGlobalStyle } from 'styled-components';

export const UptimeCenterGlobalStyle = createGlobalStyle`
* {
  scrollbar-color: ${({ theme }) => `${theme === lightTheme ? theme.colors.grey300 : theme.colors.grey600}`};
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb { /* Foreground */
    background: ${({ theme }) => (theme === lightTheme ? theme.colors.grey300 : theme.colors.grey600)};
    border-radius: 10px;
  }
  &::-webkit-scrollbar-track { /* Background */
    background: ${({ theme }) => (theme === lightTheme ? theme.colors.grey200 : theme.colors.grey800)};
    border-radius: 10px;
  }
  box-sizing: border-box;
}

body {
  height: auto;
}

header{
  *{
    box-sizing: content-box;
  }
}

:root {
  height: 100vh;
  color: ${({ theme }) => theme.colors.onSurface};
}
`;

export { paddings, borderRadius } from './variables';
